import { ProductType } from '@inter-ikea-storageone/range';
import CategoryAdditionalInlineMessage from 'components/ProductSidebar/CategoryWidget/CategoryAdditionalInlineMessage';
import { ProductListConfig } from 'rangeConfig/@types';
import addCornerFrame from 'rangeConfig/billy/behaviours/addCornerFrame';
import addMultipleFrameExtensions from 'rangeConfig/billy/behaviours/addFrameExtensions';
import { hideIfCornerFittingsNotSold } from 'rangeConfig/billy/filters/mainMenuProductFilters';
import dragAndDropFrameExtensions from 'rangeConfig/billy/behaviours/dragAndDropFrameExtension';
import { filterExtensions } from 'rangeConfig/billy/filters/mainMenuProductFilters';
import {
  placedInCorner,
  getCornerFrameImage,
  notPlacedInCorner
} from 'rangeConfig/billy/utils/cornerFrame';
import FrameExtensionsInfo from 'rangeConfig/billy/widgets/FrameExtensionsInfo/FrameExtensionsInfo';
import addProduct from 'rangeConfig/shared/behaviors/addProduct';
import withInlineMessage from 'rangeConfig/shared/widgets/withInlineMessage';

export const framesProductListConfig: ProductListConfig = {
  cardsTitle: 'name',
  cardsSubtitle: 'communicatedSizeText',
  mobileCardText: 'communicatedSizeText',
  selected: notPlacedInCorner,
  categories: [
    {
      id: 'frames',
      products: [{ path: 'type', value: ProductType.BILLY_FRAME_WITH_SHELVES_ASM }],
      categoryTitle: 'typeName, designText'
    }
  ],
  behaviors: {
    productClicked: [addProduct],
    productDropped: [addProduct]
  },
  cluster: [],
  sortOrder: [
    { path: 'dimensions.height', reverse: true },
    { path: 'dimensions.width', reverse: true }
  ],
  productFilters: []
};

export const cornerFrameProductListConfig: ProductListConfig = {
  cardsTitle: 'name',
  cardsSubtitle: 'communicatedSizeText',
  mobileCardText: 'communicatedSizeText',
  productCardMainImage: getCornerFrameImage,
  selected: placedInCorner,
  categories: [
    {
      id: 'frame-corner',
      products: [
        { path: 'type', value: ProductType.BILLY_FRAME_WITH_SHELVES_ASM },
        { path: 'communicatedDimensions.width', value: 400 },
        { path: 'communicatedDimensions.height', value: 2020 }
      ],
      categoryTitle: 'storageone.cornerBookcase, designText',
      widgets: [
        {
          component: withInlineMessage(
            'storageone.billyCornerFrameInfoMessage',
            true
          )(CategoryAdditionalInlineMessage)
        }
      ]
    }
  ],
  behaviors: {
    productClicked: [addCornerFrame],
    productDropped: [addCornerFrame]
  },
  cluster: [],
  sortOrder: [],
  productFilters: [hideIfCornerFittingsNotSold]
};

export const extensionProductListConfig: ProductListConfig = {
  cardsTitle: 'name',
  cardsSubtitle: 'communicatedSizeText',
  mobileCardText: 'communicatedSizeText',
  categories: [
    {
      id: 'frame-ext',
      products: [{ path: 'type', value: ProductType.BILLY_FRAME_EXTENSION }],
      categoryTitle: 'typeName, designText',
      widgets: [{ component: FrameExtensionsInfo }]
    }
  ],
  behaviors: {
    productClicked: [addMultipleFrameExtensions],
    productDropped: [dragAndDropFrameExtensions]
  },
  cluster: [],
  sortOrder: [
    { path: 'dimensions.height', reverse: true },
    { path: 'dimensions.width', reverse: true }
  ],
  productFilters: [filterExtensions]
};
